import axiosInstance from '@/shared/api/axios';
import type {
  ApiSupportStaffGetItem,
  ApiSupportStaffListParams,
  ApiSupportStaffListResponse,
  ApiSupportStaffPostBody,
  ApiSupportStaffPutBody,
} from '@/shared/types/api/support-staff';

const buildSupportStaffForm = (
  body: ApiSupportStaffPostBody | ApiSupportStaffPutBody,
): FormData => {
  const form = new FormData();
  form.append('name', body.name);
  form.append('contact_link', body.contact_link);
  if (body.image) form.append('image', body.image);
  if (body.experience_years !== null && body.experience_years !== undefined) {
    form.append('experience_years', String(body.experience_years));
  }
  // DRF JSONField parses a single JSON-string multipart value into a list.
  form.append('languages', JSON.stringify(body.languages));
  return form;
};

export const apiSupportStaffListGet = async (
  params: ApiSupportStaffListParams,
): Promise<ApiSupportStaffListResponse> => {
  const { data } = await axiosInstance.get<ApiSupportStaffListResponse>('/support-staff', {
    params,
  });
  return data;
};

export const apiSupportStaffDetailGet = async (
  id: string,
): Promise<ApiSupportStaffGetItem> => {
  const { data } = await axiosInstance.get<ApiSupportStaffGetItem>(`/support-staff/${id}`);
  return data;
};

export const apiSupportStaffPost = async (
  body: ApiSupportStaffPostBody,
): Promise<ApiSupportStaffGetItem> => {
  const form = buildSupportStaffForm(body);
  // Override the JSON default so the browser/axios sets the multipart boundary.
  const { data } = await axiosInstance.post<ApiSupportStaffGetItem>('/support-staff', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const apiSupportStaffPut = async (
  id: string,
  body: ApiSupportStaffPutBody,
): Promise<ApiSupportStaffGetItem> => {
  const form = buildSupportStaffForm(body);
  const { data } = await axiosInstance.put<ApiSupportStaffGetItem>(
    `/support-staff/${id}`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
};

export const apiSupportStaffDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/support-staff/${id}`);
};
